import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NavigationBinder = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const navigation = {
        push: (path) => navigate(path),
        replace: (path) => navigate(path, { replace: true }),
        go: (n) => navigate(n),
        goBack: () => navigate(-1),
        goForward: () => navigate(1),
        location: location,
        history: {
            push: (path) => navigate(path),
            replace: (path) => navigate(path, { replace: true }),
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            location: location
        }
    };

    React.useEffect(() => {
        window.navigation = navigation;
        return () => {
            delete window.navigation;
        };
    }, [navigation]);

    return children;
};

export default NavigationBinder;
